import { trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick } from "@faire/web-api/events/retailerMobile/click/footerDesktopAppModalViewOnGooglePlay";
import { trackRetailerMobileFooterDesktopappModalviewOnStoreClick } from "@faire/web-api/events/retailerMobile/click/footerDesktopAppModalViewOnStore";
import { trackEventOnClick } from "@faire/web/common/trackEvent";
import { Button } from "@faire/web/slate/Button";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

import { AppModalType } from "./AppDownload";
import { getAppsFlyerOrStoreLinks, getStoreLinkUrl } from "./utils";

interface IProps {
  appModalType: AppModalType;
  eventPrefix?: string;
}

export const ViewAppLink: React.FC<IProps> = (props) => {
  const trackEvent = () => {
    if (props.eventPrefix) {
      trackEventOnClick(`${props.eventPrefix}/app-modal/view-on-store-click`);
    } else if (!isLoggedInRetailer()) {
      if (props.appModalType === AppModalType.APPSTORE) {
        trackRetailerMobileFooterDesktopappModalviewOnStoreClick();
      } else {
        trackRetailerMobileFooterDesktopappModalviewOnGooglePlayClick();
      }
    }
  };

  const getLinks = useViewport().isMobile
    ? getAppsFlyerOrStoreLinks
    : getStoreLinkUrl;

  return (
    <Button
      variant="tertiary"
      linkTo={
        props.appModalType === AppModalType.APPSTORE
          ? getLinks().app_store_link
          : getLinks().play_store_link
      }
      target="_blank"
      onClick={() => {
        trackEvent();
      }}
    >
      {props.appModalType === AppModalType.APPSTORE ? (
        <StrictLocalMsg
          defaultMessage="View on App Store"
          description={{
            text: "Link to check our app page on App Store",
          }}
        />
      ) : (
        <StrictLocalMsg
          defaultMessage="View on Google Play"
          description={{
            text: "Link to check our app page on Google Play",
          }}
        />
      )}
    </Button>
  );
};
